"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _formatSeconds = require("@devsta/format-seconds");

var _commonReact = require("@devsta/common-react");

var _ = require(".");

require("../styles/_drawer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var UNKNOWN = 'Unknown';

function getCommentTitle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      metadata = _ref.metadata;

  if (!metadata) {
    return UNKNOWN;
  }

  try {
    var _JSON$parse = JSON.parse(metadata),
        timestamp = _JSON$parse.timestamp;

    if (!timestamp || Number.isNaN(timestamp)) {
      return UNKNOWN;
    }

    return (0, _formatSeconds.getMinutes)(timestamp);
  } catch (e) {
    return UNKNOWN;
  }
}

function groupComments(comments) {
  return comments.reduce(function (groups, comment) {
    var metadata = comment.metadata;

    if (!metadata) {
      return groups;
    }

    var _JSON$parse2 = JSON.parse(metadata),
        assetId = _JSON$parse2.assetId;

    var matchingGroupIndex = groups.findIndex(function (group) {
      return group.assetId === assetId;
    });

    if (matchingGroupIndex === -1) {
      return [].concat(_toConsumableArray(groups), [{
        assetId: assetId,
        comments: [comment],
        groupId: groups.length,
        title: "Iteration ".concat(groups.length + 1)
      }]);
    }

    var newGroups = _toConsumableArray(groups);

    var newGroup = newGroups[matchingGroupIndex];
    newGroups.splice(matchingGroupIndex, 1, _objectSpread({}, newGroup, {
      comments: [].concat(_toConsumableArray(newGroup.comments), [comment])
    }));
    return newGroups;
  }, []).filter(Boolean);
}

function DrawerComponent(_ref2) {
  var internalMode = _ref2.internalMode,
      videoName = _ref2.videoName;
  return (/*#__PURE__*/_react.default.createElement(_uiKit.Drawer, {
      className: (0, _classnames.default)('video-review-drawer', {
        'video-review-drawer--internal': internalMode
      }),
      isVertical: true,
      tabIcons: ['info', 'comments', 'review', 'video'],
      size: 390
    }, /*#__PURE__*/_react.default.createElement(_.DetailsTab, {
      videoName: videoName
    }), /*#__PURE__*/_react.default.createElement(_commonReact.CommentsTab, {
      getCommentTitle: getCommentTitle,
      isVideoReview: true,
      tabTitle: "Feedback Comments",
      groupCommentsFn: internalMode ? groupComments : void 0
    }), /*#__PURE__*/_react.default.createElement(_.AddonsTab, null), /*#__PURE__*/_react.default.createElement(_.OutputsTab, null))
  );
}

var _default = (0, _react.memo)(DrawerComponent);

exports.default = _default;